import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:3000";
const BASE_URL = `${BACKEND_URL}/api/company`;

export const companyAdminApi = createApi({
  reducerPath: "companyAdminApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.companyAuth?.token ?? localStorage.getItem("companyAdminToken");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["Profile", "Stats"],
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: () => "/profile",
      transformResponse: (response) => (response?.data != null ? response.data : response),
      providesTags: ["Profile"],
    }),
    getStats: builder.query({
      query: (days = 30) => `/stats?days=${days}`,
      transformResponse: (response) => (response?.data != null ? response.data : response),
      providesTags: ["Stats"],
    }),
  }),
});

export const { useGetProfileQuery, useLazyGetProfileQuery, useGetStatsQuery } = companyAdminApi;
